<template>
  <div class="bottomCont">
    <!-- 底部信息 -->
    <footer class="footer">
      <div class="container">
        <div class="footer-columns row">
          <div class="col-md-3 column">
            <h3>{{ $t('footer.localWebsites.title') }}</h3>
            <ul>
              <li v-for="(item,index) in $t('footer.localWebsites.list')" :key="index">
                <a :href="item.toLink">{{ item.title }}</a>
              </li>
            </ul>
          </div>
          <div class="col-md-3 column">
            <h3>{{ $t('footer.info.title') }}</h3>
            <ul>
              <li v-for="(item,index) in $t('footer.info.list')" :key="index">
                <a :href="item.toLink">{{ item.title }}</a>
              </li>
            </ul>
          </div>
          <div class="col-md-5 column">
            <h3>{{ $t('footer.contact.title') }}</h3>
            <div class="contact-info">
              <p>{{ config?.mobile }}</p>
              <p>{{ config?.address }}</p>
              <p>{{ config?.email }}</p>
            </div>
            <div class="social-links">
              <a :href="config?.facebook">
                  <img src="@/assets/bottom-f.png" alt="">
              </a>
              <a :href="config?.twitter">
                  <img src="@/assets/bottom-p.png" alt="">
              </a>
              <a :href="config?.linkedIn">
                  <img src="@/assets/bottom-in.png" alt="">
              </a>
              <a :href="config?.instagram">
                  <img src="@/assets/bottom-x.png" alt="">
              </a>
              <span></span>
            </div>
          </div>
        </div>
        <div class="copyright">
          <p>{{ $t('footer.contact.copyright') }}</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { getConfigInformation } from '@/api/komo'
export default {
  name: 'bottomCont',
  data() {
    return {
      config: {}
    }
  },
  async created () { 
    await this.initData();
  },
  methods: {
    async initData () {
      const result = await getConfigInformation();
      this.config = result.data;
    }
  }
}
</script>

<style scoped>
.bottomCont{
  width: 100%;
  height: 100%;
  /* background-image: url(../assets/bottomPhoto.png);
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: 0 0; */
  color:#fff;
  position: relative;
}
.footer {
  background-image: url(../assets/bottomPhoto.png);
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: 0 0;
  padding: 240px 0 30px;
  height: 100%;
  display: flex;
  flex-direction: column-reverse;
}

.footer-columns {
  display: flex;
  justify-content: space-between;
  margin-bottom: 40px;
  width: 100%;
  flex-direction: row;
}

.column h3 {
  margin-bottom: 20px;
  color: #333;
  font-weight: bold;
}

.column ul {
  list-style: none;
  padding: 0;
}

.column li {
  margin-bottom: 14px;
}

.column a {
  color: #1E1E1E;
  text-decoration: none;
}

.contact-info p {
  margin: 10px 0;
  color: #333;
  background: #fff;
  padding: 10px 24px;
  border-radius: 10px;
}

.social-links {
  display: flex;
  gap: 15px;
  margin-top: 44px;
  align-items: center;
}

.social-links a {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  text-decoration: none;
}
.social-links a img{
  width: 35px;
  height: 35px;
}
.social-links span {
  width: 119px;
  height: 1px;
  border: 1px solid #1E1E1E;
  margin-left: 27px;
}

.copyright {
  text-align: center;
  color: #1E1E1E;
  font-size: 12px;
  border-top: 1px solid #bcb8b8;
  padding: 28px 0 0 0;
}
@media (max-width: 768px) { 
  .footer-columns {
    gap: 18px;
  }
}
@media (max-width: 576px) { 
  .container{
    padding: 0 60px;
  }
}
</style>
